export default "__VITE_ASSET__d3f305fc__"